(function() {
  function initializeHero(section) {
    if (!section || section.dataset.heroInitialized === 'true') return;
    if (!window.EmblaCarousel) return;

    var viewport = section.querySelector('[data-hero-viewport]');
    var dotsRoot = section.querySelector('[data-hero-dots]');
    var prevButton = section.querySelector('[data-hero-prev]');
    var nextButton = section.querySelector('[data-hero-next]');
    var progressBar = section.querySelector('[data-hero-progress]');
    var autoplayDelay = Number(section.dataset.autoplayDelay || 5000);
    var slideCount = section.querySelectorAll('[data-hero-slide]').length;

    if (!viewport || slideCount <= 1) {
      section.dataset.heroInitialized = 'true';
      return;
    }

    var autoplayPlugin =
      window.EmblaCarouselAutoplay &&
      window.EmblaCarouselAutoplay({
        delay: autoplayDelay,
        stopOnInteraction: false,
        stopOnMouseEnter: true
      });

    var embla = window.EmblaCarousel(
      viewport,
      {
        loop: slideCount > 2,
        align: 'start',
        duration: 28
      },
      autoplayPlugin ? [autoplayPlugin] : []
    );

    var dotButtons = [];
    var progressTimerId;

    function updateButtons() {
      if (!embla || !prevButton || !nextButton) return;
      prevButton.disabled = !embla.canScrollPrev();
      nextButton.disabled = !embla.canScrollNext();
    }

    function updateDots() {
      var selectedIndex = embla.selectedScrollSnap();
      dotButtons.forEach(function(button, index) {
        button.classList.toggle('is-active', index === selectedIndex);
      });
    }

    function createDots() {
      if (!dotsRoot) return;
      dotsRoot.innerHTML = '';
      dotButtons = embla.scrollSnapList().map(function(_, index) {
        var button = document.createElement('button');
        button.className = 'urbanpaw-hero__dot';
        button.type = 'button';
        button.setAttribute('aria-label', 'Show slide ' + (index + 1));
        button.addEventListener('click', function() {
          embla.scrollTo(index);
        });
        dotsRoot.appendChild(button);
        return button;
      });
      updateDots();
    }

    function startProgress() {
      if (!progressBar) return;
      window.clearInterval(progressTimerId);
      progressBar.style.transition = 'none';
      progressBar.style.transform = 'scaleX(0)';

      window.requestAnimationFrame(function() {
        progressBar.style.transition = 'transform ' + autoplayDelay + 'ms linear';
        progressBar.style.transform = 'scaleX(1)';
      });
    }

    function resetProgress() {
      if (!progressBar) return;
      progressBar.style.transition = 'none';
      progressBar.style.transform = 'scaleX(0)';
    }

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        embla.scrollPrev();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        embla.scrollNext();
      });
    }

    embla.on('init', function() {
      createDots();
      updateButtons();
      updateDots();
      startProgress();
    });

    embla.on('reInit', function() {
      createDots();
      updateButtons();
      updateDots();
      startProgress();
    });

    embla.on('select', function() {
      updateButtons();
      updateDots();
      startProgress();
    });

    if (autoplayPlugin) {
      embla.on('pointerDown', resetProgress);
      embla.on('settle', startProgress);
    }

    section.dataset.heroInitialized = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-urbanpaw-hero]').forEach(function(section) {
      initializeHero(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
